import React from "react";
import {
  useAddTradeReferenceMutation,
  useUpdateTradeReferenceMutation,
  useGetCustomerDetailsQuery,
} from "../../store/api/customerApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm, useFieldArray } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useToast } from "../../hooks/useToast";
interface TradeReference {
  company_name: string;
  person_name: string;
  person_email: string;
  person_contact_number: string;
}

interface FormValues {
  trade_reference: TradeReference[];
}
const TradeReferenceForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const operation = searchParams.get("operation");
  const { showToast } = useToast();
  const [addTradeReference, { isLoading }] = useAddTradeReferenceMutation();
  const [updateTradeReference, { isLoading: isUpdateLoading }] =
    useUpdateTradeReferenceMutation();
  const { data: customerDetails } = useGetCustomerDetailsQuery(Number(id), {
    skip: !id || operation === "add",
  });
  console.log(customerDetails?.data, "asdasdasd");
  const {
    register,
    handleSubmit,
    getValues,
    control,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm<FormValues>({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: {
      trade_reference:
        customerDetails?.data?.trade_reference ||
        ([{}, {}, {}] as TradeReference[]),
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "trade_reference",
  });
  const onSubmit = async (formData: FormValues) => {
    let data = formData;
    if (data.trade_reference.length < 3) {
      setError("trade_reference", {
        type: "manual",
        message: "Please add at least 3 trade references",
      });
      return;
    }
    if (operation !== "edit") {
      const response: any = await addTradeReference({
        userId: Number(id),
        tradeReference: data.trade_reference.map((item) => ({
          companyName: item.company_name,
          personName: item.person_name,
          personEmail: item.person_email,
          personContactNumber: item.person_contact_number,
        })),
      } as any);

      if (response.error) {
        console.log(response.error);
        showToast("Error submitting form", "error");
      } else {
        console.log(response.data);
        showToast(response.data?.message, "success");
        navigate("/?tab=customers");
      }
    } else {
      const response: any = await updateTradeReference({
        userId: Number(id),
        tradeReference: data.trade_reference.map((item) => ({
          companyName: item.company_name,
          personName: item.person_name,
          personEmail: item.person_email,
          personContactNumber: item.person_contact_number,
        })),
      } as any);
      if (response.error) {
        console.log(response.error);
        showToast("Error submitting form", "error");
      } else {
        console.log(response.data);
        showToast(response.data?.message, "success");
        navigate("/?tab=customers");
      }
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex justify-content-end my-3">
          <button
            type="button"
            onClick={() => {
              if (getValues("trade_reference").length === 2) {
                clearErrors("trade_reference");
              }
              append({
                company_name: "",
                person_name: "",
                person_email: "",
                person_contact_number: "",
              });
            }}
            className="submit-button"
          >
            Add Reference
          </button>
        </div>
        {fields.map((item, index) => (
          <div
            key={item.id}
            className="d-flex gap-2 align-items-center field-array-item"
          >
            <div className="form-group">
              <label>Company Name</label>
              <input
                {...register(`trade_reference.${index}.company_name`, {
                  required: "Company Name is required",
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.company_name && (
                <span className="error-message">
                  {errors.trade_reference[index]?.company_name?.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Person Name</label>
              <input
                {...register(`trade_reference.${index}.person_name`, {
                  required: "Person Name is required",
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.person_name && (
                <span className="error-message">
                  {errors.trade_reference[index]?.person_name?.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Person Email</label>
              <input
                {...register(`trade_reference.${index}.person_email`, {
                  required: "Person Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                className="form-input"
              />
              {errors.trade_reference?.[index]?.person_email && (
                <span className="error-message">
                  {errors.trade_reference[index]?.person_email?.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <input
                {...register(`trade_reference.${index}.person_contact_number`, {
                  required: "Contact Number is required",
                  pattern: {
                    value:
                      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                    message: "Invalid contact number",
                  },
                })}
                className="form-input"
                type="tel"
              />
              {errors.trade_reference?.[index]?.person_contact_number && (
                <span className="error-message">
                  {
                    errors.trade_reference[index]?.person_contact_number
                      ?.message
                  }
                </span>
              )}
            </div>

            <div onClick={() => remove(index)} className="close-icon">
              <FaTimes />
            </div>
          </div>
        ))}
        {errors.trade_reference && (
          <span className="error-message mb-3">
            {errors.trade_reference.message}
          </span>
        )}
        <div className={`d-flex justify-content-end `}>
          <button
            type="submit"
            className="submit-button"
            disabled={isLoading || isUpdateLoading}
          >
            {isLoading || isUpdateLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TradeReferenceForm;
